/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ನಿನ್ನೆ",
        "-2": "ಮೊನ್ನೆ",
        "0": "ಇಂದು",
        "1": "ನಾಳೆ",
        "2": "ನಾಡಿದ್ದು",
        "future": {
          "one": "{0} ದಿನದಲ್ಲಿ",
          "other": "{0} ದಿನಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ದಿನದ ಹಿಂದೆ",
          "other": "{0} ದಿನಗಳ ಹಿಂದೆ"
        }
      },
      "day-narrow": {
        "-1": "ನಿನ್ನೆ",
        "-2": "ಮೊನ್ನೆ",
        "0": "ಇಂದು",
        "1": "ನಾಳೆ",
        "2": "ನಾಡಿದ್ದು",
        "future": {
          "one": "{0} ದಿನದಲ್ಲಿ",
          "other": "{0} ದಿನಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ದಿನದ ಹಿಂದೆ",
          "other": "{0} ದಿನಗಳ ಹಿಂದೆ"
        }
      },
      "day-short": {
        "-1": "ನಿನ್ನೆ",
        "-2": "ಮೊನ್ನೆ",
        "0": "ಇಂದು",
        "1": "ನಾಳೆ",
        "2": "ನಾಡಿದ್ದು",
        "future": {
          "one": "{0} ದಿನದಲ್ಲಿ",
          "other": "{0} ದಿನಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ದಿನದ ಹಿಂದೆ",
          "other": "{0} ದಿನಗಳ ಹಿಂದೆ"
        }
      },
      "hour": {
        "0": "ಈ ಗಂಟೆ",
        "future": {
          "one": "{0} ಗಂಟೆಯಲ್ಲಿ",
          "other": "{0} ಗಂಟೆಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ಗಂಟೆ ಹಿಂದೆ",
          "other": "{0} ಗಂಟೆಗಳ ಹಿಂದೆ"
        }
      },
      "hour-narrow": {
        "0": "ಈ ಗಂಟೆ",
        "future": {
          "one": "{0} ಗಂಟೆಯಲ್ಲಿ",
          "other": "{0} ಗಂಟೆಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ಗಂಟೆ ಹಿಂದೆ",
          "other": "{0} ಗಂಟೆಗಳ ಹಿಂದೆ"
        }
      },
      "hour-short": {
        "0": "ಈ ಗಂಟೆ",
        "future": {
          "one": "{0} ಗಂಟೆಯಲ್ಲಿ",
          "other": "{0} ಗಂಟೆಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ಗಂಟೆ ಹಿಂದೆ",
          "other": "{0} ಗಂಟೆಗಳ ಹಿಂದೆ"
        }
      },
      "minute": {
        "0": "ಈ ನಿಮಿಷ",
        "future": {
          "one": "{0} ನಿಮಿಷದಲ್ಲಿ",
          "other": "{0} ನಿಮಿಷಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ನಿಮಿಷದ ಹಿಂದೆ",
          "other": "{0} ನಿಮಿಷಗಳ ಹಿಂದೆ"
        }
      },
      "minute-narrow": {
        "0": "ಈ ನಿಮಿಷ",
        "future": {
          "one": "{0} ನಿಮಿಷದಲ್ಲಿ",
          "other": "{0} ನಿಮಿಷಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ನಿಮಿಷದ ಹಿಂದೆ",
          "other": "{0} ನಿಮಿಷಗಳ ಹಿಂದೆ"
        }
      },
      "minute-short": {
        "0": "ಈ ನಿಮಿಷ",
        "future": {
          "one": "{0} ನಿಮಿಷದಲ್ಲಿ",
          "other": "{0} ನಿಮಿಷಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ನಿಮಿಷದ ಹಿಂದೆ",
          "other": "{0} ನಿಮಿಷಗಳ ಹಿಂದೆ"
        }
      },
      "month": {
        "-1": "ಕಳೆದ ತಿಂಗಳು",
        "0": "ಈ ತಿಂಗಳು",
        "1": "ಮುಂದಿನ ತಿಂಗಳು",
        "future": {
          "one": "{0} ತಿಂಗಳಲ್ಲಿ",
          "other": "{0} ತಿಂಗಳುಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ತಿಂಗಳ ಹಿಂದೆ",
          "other": "{0} ತಿಂಗಳುಗಳ ಹಿಂದೆ"
        }
      },
      "month-narrow": {
        "-1": "ಕಳೆದ ತಿಂಗಳು",
        "0": "ಈ ತಿಂಗಳು",
        "1": "ಮುಂದಿನ ತಿಂಗಳು",
        "future": {
          "one": "{0} ತಿಂಗಳಲ್ಲಿ",
          "other": "{0} ತಿಂಗಳುಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ತಿಂಗಳ ಹಿಂದೆ",
          "other": "{0} ತಿಂಗಳುಗಳ ಹಿಂದೆ"
        }
      },
      "month-short": {
        "-1": "ಕಳೆದ ತಿಂಗಳು",
        "0": "ಈ ತಿಂಗಳು",
        "1": "ಮುಂದಿನ ತಿಂಗಳು",
        "future": {
          "one": "{0} ತಿಂಗಳಲ್ಲಿ",
          "other": "{0} ತಿಂಗಳುಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ತಿಂಗಳು ಹಿಂದೆ",
          "other": "{0} ತಿಂಗಳುಗಳ ಹಿಂದೆ"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "ಹಿಂದಿನ ತ್ರೈಮಾಸಿಕ",
        "0": "ಈ ತ್ರೈಮಾಸಿಕ",
        "1": "ಮುಂದಿನ ತ್ರೈಮಾಸಿಕ",
        "future": {
          "one": "{0} ತ್ರೈಮಾಸಿಕದಲ್ಲಿ",
          "other": "{0} ತ್ರೈಮಾಸಿಕಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ತ್ರೈಮಾಸಿಕದ ಹಿಂದೆ",
          "other": "{0} ತ್ರೈಮಾಸಿಕಗಳ ಹಿಂದೆ"
        }
      },
      "quarter-narrow": {
        "-1": "ಕಳೆದ ತ್ರೈಮಾಸಿಕ",
        "0": "ಈ ತ್ರೈಮಾಸಿಕ",
        "1": "ಮುಂದಿನ ತ್ರೈಮಾಸಿಕ",
        "future": {
          "one": "{0} ತ್ರೈಮಾಸಿಕಗಳಲ್ಲಿ",
          "other": "{0} ತ್ರೈಮಾಸಿಕಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ತ್ರೈ.ಮಾ. ಹಿಂದೆ",
          "other": "{0} ತ್ರೈಮಾಸಿಕಗಳ ಹಿಂದೆ"
        }
      },
      "quarter-short": {
        "-1": "ಕಳೆದ ತ್ರೈಮಾಸಿಕ",
        "0": "ಈ ತ್ರೈಮಾಸಿಕ",
        "1": "ಮುಂದಿನ ತ್ರೈಮಾಸಿಕ",
        "future": {
          "one": "{0} ತ್ರೈ.ಮಾ.ದಲ್ಲಿ",
          "other": "{0} ತ್ರೈಮಾಸಿಕಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ತ್ರೈ.ಮಾ. ಹಿಂದೆ",
          "other": "{0} ತ್ರೈಮಾಸಿಕಗಳ ಹಿಂದೆ"
        }
      },
      "second": {
        "0": "ಈಗ",
        "future": {
          "one": "{0} ಸೆಕೆಂಡ್‌ನಲ್ಲಿ",
          "other": "{0} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ಸೆಕೆಂಡ್ ಹಿಂದೆ",
          "other": "{0} ಸೆಕೆಂಡುಗಳ ಹಿಂದೆ"
        }
      },
      "second-narrow": {
        "0": "ಈಗ",
        "future": {
          "one": "{0} ಸೆಕೆಂಡ್‌ನಲ್ಲಿ",
          "other": "{0} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ಸೆಕೆಂಡ್ ಹಿಂದೆ",
          "other": "{0} ಸೆಕೆಂಡುಗಳ ಹಿಂದೆ"
        }
      },
      "second-short": {
        "0": "ಈಗ",
        "future": {
          "one": "{0} ಸೆಕೆಂಡ್‌ನಲ್ಲಿ",
          "other": "{0} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ಸೆಕೆಂಡ್ ಹಿಂದೆ",
          "other": "{0} ಸೆಕೆಂಡುಗಳ ಹಿಂದೆ"
        }
      },
      "week": {
        "-1": "ಕಳೆದ ವಾರ",
        "0": "ಈ ವಾರ",
        "1": "ಮುಂದಿನ ವಾರ",
        "future": {
          "one": "{0} ವಾರದಲ್ಲಿ",
          "other": "{0} ವಾರಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ವಾರದ ಹಿಂದೆ",
          "other": "{0} ವಾರಗಳ ಹಿಂದೆ"
        }
      },
      "week-narrow": {
        "-1": "ಕಳೆದ ವಾರ",
        "0": "ಈ ವಾರ",
        "1": "ಮುಂದಿನ ವಾರ",
        "future": {
          "one": "{0} ವಾರದಲ್ಲಿ",
          "other": "{0} ವಾರಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ವಾರದ ಹಿಂದೆ",
          "other": "{0} ವಾರಗಳ ಹಿಂದೆ"
        }
      },
      "week-short": {
        "-1": "ಕಳೆದ ವಾರ",
        "0": "ಈ ವಾರ",
        "1": "ಮುಂದಿನ ವಾರ",
        "future": {
          "one": "{0} ವಾರದಲ್ಲಿ",
          "other": "{0} ವಾರಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ವಾರದ ಹಿಂದೆ",
          "other": "{0} ವಾರಗಳ ಹಿಂದೆ"
        }
      },
      "year": {
        "-1": "ಹಿಂದಿನ ವರ್ಷ",
        "0": "ಈ ವರ್ಷ",
        "1": "ಮುಂದಿನ ವರ್ಷ",
        "future": {
          "one": "{0} ವರ್ಷದಲ್ಲಿ",
          "other": "{0} ವರ್ಷಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ವರ್ಷದ ಹಿಂದೆ",
          "other": "{0} ವರ್ಷಗಳ ಹಿಂದೆ"
        }
      },
      "year-narrow": {
        "-1": "ಕಳೆದ ವರ್ಷ",
        "0": "ಈ ವರ್ಷ",
        "1": "ಮುಂದಿನ ವರ್ಷ",
        "future": {
          "one": "{0} ವರ್ಷದಲ್ಲಿ",
          "other": "{0} ವರ್ಷಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ವರ್ಷದ ಹಿಂದೆ",
          "other": "{0} ವರ್ಷಗಳ ಹಿಂದೆ"
        }
      },
      "year-short": {
        "-1": "ಕಳೆದ ವರ್ಷ",
        "0": "ಈ ವರ್ಷ",
        "1": "ಮುಂದಿನ ವರ್ಷ",
        "future": {
          "one": "{0} ವರ್ಷದಲ್ಲಿ",
          "other": "{0} ವರ್ಷಗಳಲ್ಲಿ"
        },
        "past": {
          "one": "{0} ವರ್ಷದ ಹಿಂದೆ",
          "other": "{0} ವರ್ಷಗಳ ಹಿಂದೆ"
        }
      }
    },
    "locale": "kn"
  });
}